// extracted by mini-css-extract-plugin
export var centerText = "_ca-8";
export var container = "_ca-0";
export var doughnutContainer = "_ca-7";
export var legend = "_ca-a";
export var legendItemColorDisplay = "_ca-b";
export var legendItemLabel = "_ca-d";
export var legendItemValue = "_ca-c";
export var lg = "_ca-5";
export var maxWidth = "_ca-9";
export var md = "_ca-4";
export var responsive = "_ca-6";
export var sm = "_ca-3";
export var xs = "_ca-2";
export var xxs = "_ca-1";